import styled from "styled-components";

const OverflowSpan = styled.span<{ strong?: boolean }>`
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    @media(max-width: 600px){
        padding-right: 60px;
    }
    ${({ strong }) => strong && "font-weight: bold;"}
    align-items: center;
    display: flex;
`;

export const StyledSpan = styled.span`
    color: var(--purple-lighter);
    font-weight: bold;
    font-size: 0.82rem;
`;

export const DivProgressList = styled.div`
    display: flex;
    width: calc(100% - 50px);
`;

export default OverflowSpan;
